import React from "react";
import { Box, TextField } from "@mui/material";

export default function SectionSeo({ form, setForm }) {
    return (
        <Box sx={{ display: "grid", gap: 2 }}>
            <TextField
                fullWidth
                multiline
                minRows={3}
                label="Meta Description"
                value={form.seo_meta_description || ""}
                onChange={(e) => setForm((f) => ({ ...f, seo_meta_description: e.target.value }))}
                inputProps={{ maxLength: 320 }}
                helperText={`${String(form.seo_meta_description || "").length}/320 Zeichen`}
            />

            <TextField
                fullWidth
                multiline
                minRows={2}
                label="Meta Keywords"
                value={form.seo_meta_keywords || ""}
                onChange={(e) => setForm((f) => ({ ...f, seo_meta_keywords: e.target.value }))}
                placeholder="hotel, restaurant, schweiz"
            />
        </Box>
    );
}
